module.exports = __webpack_public_path__ + "static/test-6d13af800ffb093634cdb0e527dee527.jpg";